import { LEAVE_TYPE_LABELS_KO } from '@lemoment/shared';

import { useTeamToday } from '../hooks';
import { colorForId } from './colors';

export const TodayAwayList = () => {
  const { data, isLoading, isError } = useTeamToday();
  const items = data?.items ?? [];

  return (
    <section className="lift rounded-2xl border border-border bg-card/80 p-5">
      <div className="flex items-baseline justify-between">
        <h2 className="font-display text-base font-bold tracking-tight text-foreground">
          오늘 자리 비움
        </h2>
        {!isLoading && !isError && (
          <span className="font-numeral text-2xl font-bold leading-none text-lemon-ink dark:text-lemon">
            {items.length}
            <span className="ml-0.5 text-xs font-medium text-muted-foreground">
              명
            </span>
          </span>
        )}
      </div>

      <div className="rule-citrus my-4" />

      {isLoading && (
        <div role="status" className="flex flex-col gap-3.5">
          <span className="sr-only">불러오는 중</span>
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex items-center gap-3" aria-hidden>
              <span className="skeleton h-2.5 w-2.5 rounded-full" />
              <span className="skeleton h-4 w-24 rounded" />
              <span className="skeleton ml-auto h-4 w-12 rounded" />
            </div>
          ))}
        </div>
      )}

      {!isLoading && isError && (
        <p className="text-sm text-destructive">불러오지 못했습니다</p>
      )}

      {!isLoading && !isError && items.length === 0 && (
        <p className="text-sm text-muted-foreground">
          오늘 자리를 비운 사람이 없습니다.
        </p>
      )}

      {!isLoading && !isError && items.length > 0 && (
        <ul className="flex flex-col gap-3.5">
          {items.map(({ crew, leave }) => (
            <li
              key={`${crew.id}-${leave.id}`}
              className="-mx-2 flex items-center gap-3 rounded-lg px-2 py-1.5 transition-colors hover:bg-accent"
            >
              <span
                className="h-2.5 w-2.5 shrink-0 rounded-full ring-2 ring-background"
                style={{ backgroundColor: colorForId(crew.calendarColorId) }}
              />
              <span className="font-medium text-foreground">
                {crew.displayName}
              </span>
              <span className="ml-auto font-display text-sm text-muted-foreground">
                {LEAVE_TYPE_LABELS_KO[leave.type]}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
